import { createTheme, darken, lighten, ThemeOptions } from '@mui/material';
import { ButtonTheme } from './components/ButtonTheme';
import { ChipTheme } from './components/ChipTheme';

export const getTheme = (brandColor: string = '#4B22A8'): ThemeOptions =>
  createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: brandColor,
        light: lighten(brandColor, 0.7),
        dark: darken(brandColor, 0.2)
      },
      secondary: {
        main: '#777'
      },
      warning: {
        main: '#EE9518',
        light: '#FFF2DF'
      },
      info: {
        main: '#ECECEC'
      },
      error: {
        main: '#DA0808',
        light: '#FFCECE'
      },
      success: {
        main: '#00860D',
        light: '#DAFFDD'
      },
      text: {
        primary: '#242424',
        secondary: '#888888',
        disabled: '#777777'
      },
      background: {
        default: '#F8F9FA',
        paper: '#FFFFFF'
      },
      common: {
        black: '#09090A',
        white: '#FFFFFF'
      }
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: `
          @font-face {
            font-family: 'Inter', 'sans-serif';
            font-display: swap;
          }
        `
      },
      MuiButton: ButtonTheme(),
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            marginLeft: 0
          }
        }
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            '&.Mui-disabled': {
              backgroundColor: '#f0f0f0'
            }
          }
        }
      },
      MuiFormLabel: {
        styleOverrides: {
          asterisk: {
            color: '#DA0808',
            '&$error': {
              color: '#DA0808'
            }
          }
        }
      },
      MuiTable: {
        styleOverrides: {
          root: {
            tableLayout: 'fixed'
          }
        }
      },
      MuiChip: ChipTheme(),
      MuiTabs: {
        styleOverrides: {
          root: {
            minHeight: '40px'
          },
          indicator: {
            display: 'none'
          }
        }
      },
      MuiTab: {
        styleOverrides: {
          root: {
            borderRadius: '8px',
            textTransform: 'none',
            minHeight: '40px',
            padding: '8px 16px',
            '&.Mui-selected': {
              backgroundColor: lighten(brandColor, 0.7),
              color: brandColor
            }
          }
        }
      }
    },
    typography: {
      fontFamily: ['Inter', 'sans-serif'].join(','),
      body1: {
        fontSize: '1rem',
        lineHeight: '1.5rem'
      },
      body2: {
        fontSize: '0.875rem',
        lineHeight: '1.25rem'
      },
      h1: {
        fontSize: '1.5rem',
        lineHeight: '2rem'
      },
      h2: {
        fontSize: '1.25rem',
        lineHeight: '1.75rem'
      },
      h3: {
        fontSize: '0.875rem',
        lineHeight: '1.25rem'
      }
    }
  });
